import React from 'react';

import { FLink } from '@components';
import { useSelector } from 'react-redux';
import { currency } from '@utils';
import {
  EMPRESTIMO_CONSCIENTE,
  TIRA_DUVIDAS,
  REGULAMENTO_EMPRESTIMO,
  SIMULADOR_ABSOLUTE_PATH,
} from '../../../utils/paths';

export const EmprestimosCard = () => {
  const { simular_emprestimo: showSimular } = useSelector(
    (state) => state.telasDisponiveis
  );
  const limite = useSelector((state) => state.emprestimo.limite.total);

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-2">Empréstimos</h1>
        <p className="ts-14 text-muted mb-2">
          Antes de contratar um empréstimo analise os itens abaixo.
        </p>
        <hr className="mb-3" />
        <FLink icon to={EMPRESTIMO_CONSCIENTE}>
          Saiba mais sobre crédito consciente
        </FLink>
        <hr className="my-3" />
        <FLink icon to={TIRA_DUVIDAS}>
          Tire suas dúvidas
        </FLink>
        <hr className="my-3" />
        <FLink icon to={REGULAMENTO_EMPRESTIMO}>
          Leia o regulamento
        </FLink>
        <hr className="my-3" />
        {showSimular && (
          <FLink icon to={SIMULADOR_ABSOLUTE_PATH}>
            Simulação de empréstimo
          </FLink>
        )}

        {showSimular && !!limite && (
          <div>
            <hr className="my-3 mt-32" />
            <p className="ts-14 text-muted">
              Seu limite pré-aprovado na data de hoje:{' '}
              {currency(Math.floor(limite))}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
